import axios from "axios";
import { API, Endpoints } from "./Constants";
import JSZip from "jszip";

export const getAuthString = () => {
  let token = localStorage.getItem("dealerModuleToken");
  if (token == null) {
    token = "";
  }
  return token;
};

export const getFileType = (fileName) => {
  // Use a regular expression to extract the file extension
  const fileExtension = fileName.match(/\.[^.]+$/);

  // Check if a file extension was found
  if (fileExtension && fileExtension[0]) {
    // Return the file extension without the dot (e.g., "jpg" instead of ".jpg")
    return fileExtension[0].substring(1).toLowerCase();
  } else {
    // If no file extension was found, or the file name was empty, return null or handle accordingly.
    return null;
  }
};

export const isAnyKeyEmpty = (obj) => {
  for (const key in obj) {
    if (
      obj[key] === null ||
      obj[key] === undefined ||
      obj[key] === "" ||
      obj[key].length === 0
    ) {
      return true;
    }
  }
  return false;
};

export const hasKeysAndNotEmpty = (obj, keysToCheck, declaration) => {
  // Check if all keys in 'keysToCheck' exist in 'obj' and are not empty
  if (declaration) {
    return Object.keys(keysToCheck).every(
      (key) =>
        obj.hasOwnProperty(key) && obj[key] !== undefined && obj[key] !== ""
    );
  } else {
    return Object.keys(keysToCheck).every(
      (key) =>
        obj.hasOwnProperty(key) &&
        obj[key] !== null &&
        obj[key] !== undefined &&
        obj[key] !== ""
    );
  }
};

export const validateRequiredFields = (value, requiredFields) => {
  // console.log("requiredFields", value, requiredFields)
  if (value === null || value === undefined) {
    return false
  } else {
    if (requiredFields !== null && requiredFields !== undefined) {
      for (const key in requiredFields) {
        if (requiredFields.hasOwnProperty(key)) {
          if (
            !value.hasOwnProperty(key) ||
            value[key] === null ||
            value[key] === undefined ||
            value[key] === "" ||
            value[key].length == 0
          ) {
            return false;
          }
        }
      }
      return true;
    }
  }
};

export const checkValidations = (obj) => {
  for (let key in obj) {

    console.log("inside validate declaration===========", obj[key]["validation"])
    if (obj[key]["validation"] === false) {
      return false;
    }
  }
  return true;
};

// export const checkValidations = (obj) => {
//   for (let key in obj) {
//     const field = obj[key];

//     // Only check fields that have validation = true
//     if (field.validation === true) {
//       const value = field.value;
//       console.log("inside validate declaration===========", value)
//       // Check for null, undefined, empty string, or empty array
//       if (
//         value === null ||
//         value === undefined ||
//         value === "" ||
//         (Array.isArray(value) && value.length === 0)
//       ) {
//         console.log(`Validation failed for key: ${key}, value:`, value);
//         return false;
//       }
//     }
//   }
//   return true;
// };

export const clearLocalStorageExceptOne = (keysToRetain) => {
  const keys = Object.keys(localStorage);

  // Loop through the keys and remove items that are not in keysToRetain
  keys.forEach((key) => {
    if (!keysToRetain.includes(key)) {
      localStorage.removeItem(key);
    }
  });
};

export const areSteps1To6Completed = () => {
  // const stepsToCheck = ["step1", "step2", "step3", "step4", "step5", "step6"];
  const stepsToCheck = ["step1", "step2", "step3", "step4", "step5",];
  // const stepsToCheck = [];
  const stepsStatus = [];

  // console.log("status 1 to 6 stepsToCheck=====================", stepsToCheck)
  let obj = JSON.parse(localStorage.getItem("stepStatus"));
  console.log("list steps =====================", obj)

  if (obj) {
    for (const step of stepsToCheck) {
      if (!obj[step].completed) {
        // console.log("status 1 to 6 if part===================", obj[step])
        stepsStatus.push(false);
        // console.log("status 1 to 6 stepsStatus=======if==============", stepsStatus)

      } else {
        // console.log("status 1 to 6 else part===================")
        stepsStatus.push(true);
        // console.log("status 1 to 6 stepsStatus=========else============", stepsStatus)

      }
    }
    if (stepsStatus.includes(false)) {
      // console.log("final ")
      return false;
    } else {
      // console.log("agsdasidagu")
      return true;
    }
  } else {
    return true;
  }
};

export const convertObject = (obj, declaration) => {
  let convertedObj = {};
  if (declaration == true) {
    for (let key in obj) {
      convertedObj[key] = {
        value: obj[key],
        validation:
          obj[key] !== "" || Number.isInteger(obj[key]) ? true : false,
      };
    }
  } else {
    for (let key in obj) {
      convertedObj[key] = {
        value: obj[key],
        validation: obj[key] != "" || Number.isInteger(obj[key]) ? true : false,
      };
    }
  }

  return convertedObj;
};

export const signInDisabled = (name) => {
  console.log('name====', name)
  return name == 'Singapore Citizen' ? true : false;

}

export const reverseObject = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map((item) => reverseObject(item));
  } else if (typeof obj === "object") {
    if (obj) {
      if ("value" in obj) {
        return obj.value;
      } else {
        const newObj = {};
        for (const key in obj) {
          newObj[key] = reverseObject(obj[key]);
        }
        return newObj;
      }
    }
  }
};

export const removeEmptyValues = (obj) => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
        delete obj[key];
      }
    }
  }
  return obj;
};

export const objToArray = (obj) => {
  let resultArray = [];

  for (let key in obj) {
    if (obj[key].length > 0 && obj[key] != "") {
      let a = {};
      a[key] = obj[key];
      resultArray.push(a);
    }
  }

  return resultArray;
};
const accessToken = localStorage.getItem("dealerModuleToken");

export const downloadFlooringDocuments = async (type, appId, formType) => {
  try {
    const response = await axios.get(
      API.BaseUrl +
      Endpoints.downloadFlooringDocumnets +
      `${appId}` +
      "/" +
      formType,
      {
        responseType: "arraybuffer", // Important for handling binary data
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    // Create a Blob from the Base64-encoded data
    const blob = new Blob([response.data], { type: "application/zip" });
    // Create a URL for the Blob data
    const url = URL.createObjectURL(blob);
    // Create a download link
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = type + "_documents.zip";
    document.body.appendChild(a);
    // Trigger the download
    a.click();
    // Clean up the URL object to free resources
    URL.revokeObjectURL(url);
    // Remove the download link from the document
    document.body.removeChild(a);
  } catch (error) {
    console.error("Error downloading documents:", error);
  }
};

export const downloadFlooringDocumentsUnzip = async (type, appId, formType) => {
  try {
    const response = await axios.get(
      API.BaseUrl +
      Endpoints.downloadFlooringDocumnets +
      `${appId}` +
      "/" +
      formType,
      {
        responseType: "arraybuffer", // Important for handling binary data
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    // Create a Blob from the Base64-encoded data
    const blob = new Blob([response.data], { type: "application/zip" });
    const zip = await JSZip.loadAsync(blob);

    // Iterate through the files in the zip and create download links for each file
    zip.forEach(async (relativePath, file) => {
      const fileBlob = await file.async("blob");
      const url = URL.createObjectURL(fileBlob);

      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = relativePath; // Use the file's original name
      document.body.appendChild(a);

      a.click();

      // Clean up the URL object and remove the download link
      URL.revokeObjectURL(url);
      document.body.removeChild(a);
    });
  } catch (error) {
    console.error("Error downloading documents:", error);
  }
};


export const downloadLoanApplicationProductFormsZip = async (appId) => {
  try {
    const response = await axios.get(
      API.BaseUrl +
      `loan/application/form/bulk/download/${appId}`,
      {
        responseType: "arraybuffer", // Important for handling binary data
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    // Create a Blob from the Base64-encoded data
    const blob = new Blob([response.data],);
    // Create a URL for the Blob data
    const url = URL.createObjectURL(blob);
    // Create a download link
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = 'application-form-' + appId + "_documents.zip";
    document.body.appendChild(a);
    // Trigger the download
    a.click();
    // Clean up the URL object to free resources
    URL.revokeObjectURL(url);
    // Remove the download link from the document
    document.body.removeChild(a);
  } catch (error) {
    console.error("Error downloading documents:", error);
  }
};


export const downloadLoanApplicationProductForms = async (appId) => {
  try {
    const response = await axios.get(
      API.BaseUrl +
      `loan/application/form/bulk/download/${appId}`,
      {
        responseType: "arraybuffer", // Important for handling binary data
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    // Create a Blob from the Base64-encoded data
    const blob = new Blob([response.data], { type: "application/zip" });
    const zip = await JSZip.loadAsync(blob);

    // Iterate through the files in the zip and create download links for each file
    zip.forEach(async (relativePath, file) => {
      const fileBlob = await file.async("blob");
      const url = URL.createObjectURL(fileBlob);

      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = relativePath; // Use the file's original name
      document.body.appendChild(a);

      a.click();

      // Clean up the URL object and remove the download link
      URL.revokeObjectURL(url);
      document.body.removeChild(a);
    });
  } catch (error) {
    console.error("Error downloading documents:", error);
  }
};

export const downloadDocuments = async (type, id) => {
  try {
    const response = await axios.get(
      id !== undefined
        ? `${API.BaseUrl +
        Endpoints.downloadDocuments +
        localStorage.getItem("applicationId") +
        "/" +
        type +
        "/" +
        id
        }`
        : `${API.BaseUrl +
        Endpoints.downloadDocuments +
        localStorage.getItem("applicationId") +
        "/" +
        type
        }`,
      {
        responseType: "arraybuffer", // Important for handling binary data
      }
    );
    // Create a Blob from the Base64-encoded data
    const blob = new Blob([response.data], { type: "application/zip" });
    // Create a URL for the Blob data
    const url = URL.createObjectURL(blob);
    // Create a download link
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = type + "_documents.zip";
    document.body.appendChild(a);
    // Trigger the download
    a.click();
    // Clean up the URL object to free resources
    URL.revokeObjectURL(url);
    // Remove the download link from the document
    document.body.removeChild(a);
  } catch (error) {
    console.error("Error downloading documents:", error);
  }
};

export const downloadDocumentsUnzip = async (type, id) => {
  try {
    const response = await axios.get(
      id !== undefined
        ? `${API.BaseUrl +
        Endpoints.downloadDocuments +
        localStorage.getItem("applicationId") +
        "/" +
        type +
        "/" +
        id
        }`
        : `${API.BaseUrl +
        Endpoints.downloadDocuments +
        localStorage.getItem("applicationId") +
        "/" +
        type
        }`,
      type,
      {
        responseType: "arraybuffer", // Important for handling binary data
      }
    );
    // Create a Blob from the Base64-encoded data
    const blob = new Blob([response.data], { type: "application/zip" });
    const zip = await JSZip.loadAsync(blob);

    // Iterate through the files in the zip and create download links for each file
    zip.forEach(async (relativePath, file) => {
      const fileBlob = await file.async("blob");
      const url = URL.createObjectURL(fileBlob);

      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = relativePath; // Use the file's original name
      document.body.appendChild(a);

      a.click();

      // Clean up the URL object and remove the download link
      URL.revokeObjectURL(url);
      document.body.removeChild(a);
    });
  } catch (error) {
    console.error("Error downloading documents:", error);
  }
};

export const downloadApplications = async () => {
  try {
    const response = await axios.get(
      API.BaseUrl +
      Endpoints.downloadAllApplications +
      localStorage.getItem("applicationId") +
      "/all",
      {
        responseType: "arraybuffer", // Important for handling binary data
      }
    );
    // Create a Blob from the Base64-encoded data
    const blob = new Blob([response.data], { type: "application/zip" });
    // Create a URL for the Blob data
    const url = URL.createObjectURL(blob);
    // Create a download link
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = "applications.zip";
    document.body.appendChild(a);
    // Trigger the download
    a.click();
    // Clean up the URL object to free resources
    URL.revokeObjectURL(url);
    // Remove the download link from the document
    document.body.removeChild(a);
  } catch (error) {
    console.error("Error downloading documents:", error);
  }
};

export const handleDownload = async (url) => {
  try {
    const response = await fetch(url);
    if (response.ok) {
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = "summary.pdf";
      link.click();
    }
  } catch (error) { }
};
